/**
 * <mb-back-to-top>: botão flutuante "voltar ao topo" (portado de utilities.js backToTop do tema anterior).
 * Aparece depois de 150 px de rolagem e sobe com rolagem suave (respeita prefers-reduced-motion).
 */
class MbBackToTop extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('.back-to-top-button');
    if (!this.button) return;

    this.button.addEventListener('click', () => {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    });

    this.onScroll = () => this.button.classList.toggle('-visible', window.scrollY > 150);
    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.onScroll();
  }

  disconnectedCallback() {
    if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
  }
}

if (!customElements.get('mb-back-to-top')) customElements.define('mb-back-to-top', MbBackToTop);
